import dayjs from "dayjs";
import { IExpensesList } from "types/Logistic";
import { IDeliveryTrip } from "types/Logistic/deliveryTrip";
import * as Yup from "yup";
import { v4 as uuidv4 } from "uuid";
import { stringMaxInput } from "utils/Validate";
import { DriverNo } from "generated/sales";

export const incomeItemsConfig = [
  { uid: "SP00001", withholding_tax_type: "1" },
  { uid: "SP00003", withholding_tax_type: "3" },
] as const;

export const expenseItemsPrimaryConfig = [
  { uid: "SP00005", withholding_tax_type: "3" },
  { uid: "SP00006", withholding_tax_type: "3" },
  { uid: "SP00016", withholding_tax_type: "3" },
  { uid: "SP00009", withholding_tax_type: "0" },
] as const;

export const expenseItemsSecondaryConfig = [
  { uid: "SP00005", withholding_tax_type: "3" },
  { uid: "SP00006", withholding_tax_type: "3" },
  { uid: "SP00016", withholding_tax_type: "3" },
] as const;

export const expensesListData: IExpensesList[] = [
  {
    unique_id: uuidv4(),
    item_id: 161,
    item_unique_id: "SP00005",
    item_name: "ค่าเบี้ยเลี้ยงคนขับ",
    item_sku_desc: "ใช้สำหรับคิดค่าเบี้ยเลี้ยงคนขับ",
    qty: 1,
    uom_id: 170,
    uom_name: "เที่ยว",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "3",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Primary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
  {
    unique_id: uuidv4(),
    item_id: 162,
    item_unique_id: "SP00006",
    item_name: "ค่า Drop",
    item_sku_desc: "ใช้สำหรับคิดค่า Drop",
    qty: 1,
    uom_id: 172,
    uom_name: "จุด",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "3",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Primary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
  {
    unique_id: uuidv4(),
    item_id: 169,
    item_unique_id: "SP00016",
    item_name: "ค่าส่วนต่างน้ำมัน",
    item_sku_desc: "",
    qty: 1,
    uom_id: 171,
    uom_name: "ลิตร",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "3",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Primary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
  {
    unique_id: uuidv4(),
    item_id: 2089,
    item_unique_id: "SP00009",
    item_name: "ค่าทางด่วน",
    item_sku_desc: "ใช้สำหรับคิดค่าทางด่วน",
    qty: 1,
    uom_id: 170,
    uom_name: "เที่ยว",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "0",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Primary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
];

export const expensesListData2: IExpensesList[] = [
  {
    unique_id: uuidv4(),
    item_id: 161,
    item_unique_id: "SP00005",
    item_name: "ค่าเบี้ยเลี้ยงคนขับ",
    item_sku_desc: "ใช้สำหรับคิดค่าเบี้ยเลี้ยงคนขับ",
    qty: 1,
    uom_id: 170,
    uom_name: "เที่ยว",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "3",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Secondary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
  {
    unique_id: uuidv4(),
    item_id: 162,
    item_unique_id: "SP00006",
    item_name: "ค่า Drop",
    item_sku_desc: "ใช้สำหรับคิดค่า Drop",
    qty: 1,
    uom_id: 172,
    uom_name: "จุด",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "3",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Secondary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
  {
    unique_id: uuidv4(),
    item_id: 0,
    item_unique_id: "SP00016",
    item_name: "ค่าส่วนต่างน้ำมัน",
    item_sku_desc: "",
    qty: 1,
    uom_id: 171,
    uom_name: "ลิตร",
    uom_conversion_list: [],
    discount: 0,
    pre_vat_amount: 0,
    price_per_unit: 0,
    withholding_tax_type: "3",
    withholding_tax_value: 0,
    vat_percentage: "ไม่มี",
    driver_no: DriverNo.Secondary,
    net_amount: 0,
    withholding_tax_amount: 0,
    total_amount: 0,
  },
];

export const deliveryTripSchema: IDeliveryTrip = {
  unique_id: "",
  // `main_status` = saved-frozen value (feeds the badge; badge is hidden
  // in create anyway). `new_main_status` = dropdown buffer.
  // 86d4889jb D8 — defaults to "booking". A trip is nearly always entered at
  // the moment the customer phones to reserve it, so that is the honest
  // starting point; the admin moves it on once a truck is assigned.
  main_status: "",
  new_main_status: "booking",
  sub_status: "",
  aggrid_status: "",
  flag_status: [],
  job_no: "",
  related_user_list: [],
  created_by: null,
  created_date: dayjs(),
  last_updated_by: undefined,
  last_updated_date: undefined,
  issue_date: dayjs(),
  vehicle_id: undefined,
  vehicle: {
    type: "",
    vehicle_no: "",
    license_plate: "",
  },
  trailer_id: undefined,
  trailer: {
    trailer_no: "",
    license_plate: "",
  },
  primary_driver: undefined,
  secondary_driver: undefined,
  customer_details: {
    unique_id_name: "",
    name: "",
    phone: "",
    email: "",
    fax: "",
    identity_no: "",
    billing_address: {
      address_name: "",
      sub_district: "",
      district: "",
      province: "",
      postal_code: "",
      country: "",
    },
    delivery_address: {
      type: "",
      contact_name: "",
      contact_phone: "",
      fax: "",
      address_name: "",
      sub_district: "",
      district: "",
      province: "",
      postal_code: "",
      country: "",
    },
  },
  container_type: "",
  item_type: "",
  item_amount: undefined,
  temperature_type: "",
  packaging_location: "",
  expected_temperature: undefined,
  plan_start_date: dayjs(),
  plan_end_date: dayjs(),
  actual_start_date: undefined,
  actual_end_date: undefined,
  start_kilometer: undefined,
  end_kilometer: undefined,
  total_kilometer_distance: undefined,
  temperature_start_hours: undefined,
  temperature_end_hours: undefined,
  total_temperature_hours: undefined,
  route_code: "",
  plan_distance: undefined,
  fuel_price: undefined,
  fuel: {
    // 86d37db3t: actuals default 0 (never null) per sheet.
    appa: 0,
    actual_fleet: 0,
    other: 0,
    // 86d4889jb — `0.00` instead of blank so a booking taken over the phone
    // clears the (unchanged) required rule without the admin typing anything.
    total_quota: 0,
    total_usage: undefined,
  },
  work_list: [],
  work_total_amount: 0,
  max_shipping_cost: 0,
  secondary_driver_cost: 0,
  drop_cost: 0,
  income_list: [],
  income_post_discount_amount: 0,
  income_vat_exempted_amount: 0,
  income_vat_0_percent_amount: 0,
  income_vat_7_percent_amount: 0,
  income_vat_amount: 0,
  income_net_amount: 0,
  income_withholding_tax_amount: 0,
  income_total_amount: 0,
  expenses_list: [],
  expenses_post_discount_amount: 0,
  expenses_vat_exempted_amount: 0,
  expenses_vat_0_percent_amount: 0,
  expenses_vat_7_percent_amount: 0,
  expenses_vat_amount: 0,
  expenses_net_amount: 0,
  expenses_withholding_tax_amount: 0,
  expenses_total_amount: 0,
  attachment_list: [],
  remark: "",
  reference_document_list: [],
  // 86d37db3t: payment_date default blank — list-view paid flag now derives
  // from whether it's filled. Pre-filling would mark every doc as paid.
  payment_date: undefined,
  accepted_date: dayjs(),
  payment_detail: "",
  created_payment_date: undefined,
};

const yupNumber = Yup.number().transform((value) =>
  isNaN(value) || value === null || value === undefined ? 0 : value,
);

// 86d37db3t — per-stop coordinator name/phone (and customer_name) become
// optional per the Required→Optional table. Only รหัสสถานที่ / ชื่อสถานที่ /
// รับ/ส่ง stay required on a row.
const workListValidation = Yup.object().shape({
  type: Yup.string().required("กรุณาระบุ"),
  coordinator_name: Yup.string().notRequired(),
  coordinator_phone: Yup.string().notRequired(),
  customer_name: Yup.string().notRequired(),
  special_request: stringMaxInput(100, undefined, false),
  reference_code: stringMaxInput(200, undefined, false),
  seal_no: stringMaxInput(15, undefined, false),
  shipping_cost: yupNumber,
});

// 86d4889jb — accept `0`. At booking time neither quantity nor price is known
// yet, but the rows are still worth capturing as a preset to fill in later.
// Still `.required()`: the field must be filled, `0` is simply a legal value.
// Deliberately looser than the expenses rule below, which keeps `qty > 0`.
const incomeListValidation = Yup.object().shape({
  qty: yupNumber.min(0, "กรุณาระบุ").required("กรุณาระบุ"),
  price_per_unit: yupNumber.min(0, "กรุณาระบุ").required("กรุณาระบุ"),
});

// 86d37db3t — skip per-row validation for orphan rows (rows whose driver
// isn't set on the DT). `this.from` in a Yup test walks ancestry:
//   from[0] = the row itself, from[1] = the DT root.
const rowHasDriver = (ctx: any): boolean => {
  const root = ctx.from?.[1]?.value;
  const driverNo = ctx.parent?.driver_no;
  if (driverNo === "primary") return !!root?.primary_driver?.name;
  if (driverNo === "secondary") return !!root?.secondary_driver?.name;
  return true;
};

const expensesListValidation = Yup.object().shape({
  item_unique_id: Yup.string().test("required-with-driver", "", function (value) {
    if (!rowHasDriver(this)) return true;
    return !!value;
  }),
  // 86d37db3t: allow negative qty for the expanded allow-negative set
  // (SP00004, SP00015, SP00016 = ค่าส่วนต่างน้ำมัน). Others still must be > 0.
  qty: Yup.number()
    .typeError("กรุณาระบุ")
    .test("qty-condition", "กรุณาระบุ", function (value) {
      if (!rowHasDriver(this)) return true;
      if (value === undefined || value === null || isNaN(value)) {
        return this.createError({ message: "กรุณาระบุ" });
      }
      const { item_unique_id } = this.parent;
      if (
        item_unique_id !== "SP00004" &&
        item_unique_id !== "SP00015" &&
        item_unique_id !== "SP00016"
      ) {
        return value > 0;
      }
      return true;
    }),
  price_per_unit: Yup.number()
    .typeError("กรุณาระบุ")
    .test("price-per-unit-required", "กรุณาระบุ", function (value) {
      if (!rowHasDriver(this)) return true;
      // 86d4889jb — `>= 0`. The form seeds these rows itself at
      // `qty 1 / price 0` the moment a driver is picked, then the old `> 0`
      // rule refused to save them. This removes that contradiction.
      return (
        value !== undefined && value !== null && !isNaN(value) && value >= 0
      );
    }),
});

// 86d37db3t — every field visible/editable in every status; required set
// is status-independent. All the `.when("main_status", ...)` gates are gone.
export const deliveryTripValidation = Yup.object().shape({
  unique_id: stringMaxInput(15, undefined, true),
  job_no: stringMaxInput(200, undefined, false),
  item_type: stringMaxInput(200, undefined, false),
  item_amount: stringMaxInput(200, undefined, false),
  packaging_location: stringMaxInput(200, undefined, false),
  expected_temperature: stringMaxInput(200, undefined, false),
  temperature_type: Yup.string().required("กรุณาระบุ"),
  route_code: Yup.string().trim().max(50).notRequired(),
  plan_distance: yupNumber.notRequired(),
  fuel_price: yupNumber.notRequired(),
  issue_date: Yup.date().required("กรุณาระบุ"),
  vehicle: Yup.object().shape({
    // 86d4889jb — all three are filled only by choosing a vehicle, which a
    // phone booking cannot do yet, so none of them is required. `type` was
    // briefly made editable and required; that was reversed (D12) because
    // disabled + required cannot both hold for a booking with no vehicle.
    type: Yup.string(),
    vehicle_no: Yup.string(),
    license_plate: Yup.string(),
  }),
  // Saved status — feeds the badge, never validated (write-only from the
  // save payload). The dropdown binds to `new_main_status` below.
  main_status: Yup.string(),
  new_main_status: Yup.string().required("กรุณาระบุ"),
  aggrid_status: Yup.string(),
  customer_unique_id: Yup.string().required("กรุณาระบุ"),
  plan_start_date: Yup.date().notRequired().nullable(),
  plan_end_date: Yup.date()
    .notRequired()
    .nullable()
    .min(Yup.ref("plan_start_date"), "กรุณาระบุข้อมูลให้ถูกต้อง"),
  actual_start_date: Yup.date().notRequired().nullable(),
  actual_end_date: Yup.date()
    .notRequired()
    .nullable()
    .min(Yup.ref("actual_start_date"), "กรุณาระบุข้อมูลให้ถูกต้อง"),
  start_kilometer: yupNumber.notRequired(),
  end_kilometer: yupNumber.notRequired(),
  total_kilometer_distance: yupNumber.notRequired(),
  temperature_start_hours: yupNumber,
  temperature_end_hours: yupNumber,
  total_temperature_hours: yupNumber,
  work_list: Yup.array().of(workListValidation),
  income_list: Yup.array().of(incomeListValidation),
  expenses_list: Yup.array().of(expensesListValidation),
  fuel: Yup.object().shape({
    // Actuals: `M` per sheet with default 0. `0` satisfies `.required()` so
    // UX is effectively "optional with a 0 fallback".
    appa: Yup.number().typeError("กรุณาระบุ").required("กรุณาระบุ").default(0),
    actual_fleet: Yup.number()
      .typeError("กรุณาระบุ")
      .required("กรุณาระบุ")
      .default(0),
    other: Yup.number()
      .typeError("กรุณาระบุ")
      .required("กรุณาระบุ")
      .default(0),
    total_quota: Yup.number()
      .typeError("กรุณาระบุ")
      .moreThan(-1)
      .required("กรุณาระบุ"),
  }),
  primary_driver: Yup.object()
    .shape({
      name: Yup.string(),
    })
    .notRequired(),
});
